<template>
  <div>
    <md-dialog
      :md-active.sync="showBundlesDialog"
      @md-closed="onClose"
    >
      <div class="container">
        <md-dialog-title>Edit server bundles of {{ (node.server_address || node.slug) || '' }}</md-dialog-title>

        <md-dialog-content>
          <div>
            <div
              v-for="sb in newServerBundles"
              :key="sb.id"
              class="sb-row"
            >
              <span>{{ sb.name }}</span>
              <md-button
                class="md-icon-button md-primary"
                @click="removeServerBundle(sb.id)"
              >
                <md-icon>delete</md-icon>
              </md-button>
            </div>
          </div>

          <div class="autocomplete-wrapper">
            <md-autocomplete
              v-model="inputValue"
              :md-options="remainingOptions"
              @md-selected="addServerBundle"
            >
              <label>Add Server Bundles</label>
            </md-autocomplete>
          </div>
        </md-dialog-content>

        <md-dialog-actions>
          <md-button
            class="cancelButton"
            @click="onClose"
          >
            Cancel
          </md-button>
          <md-button
            class="md-primary"
            @click="onSubmit"
          >
            Save
          </md-button>
        </md-dialog-actions>
      </div>
    </md-dialog>
  </div>
</template>

<script>
export default {
    name: "ServerBundleDialog",
    props: {
        showBundlesDialog: Boolean,
        node: { type: Object, required: true },
        onClose: { type: Function, required: true },

        isShortcutMode: Boolean
    },
    data() {
        return {
            newServerBundles: this.$props.node ? this.$props.node.server_bundles : [],
            serverBundlesOptions: [],

            inputValue: "",
        };
    },
    computed: {
        remainingOptions() {
            return this.serverBundlesOptions.filter(b => this.newServerBundles.every(nb => nb.id !== b.id)).map(sb => sb.name);
        }
    },
    watch: {
        showBundlesDialog() {
            this.newServerBundles = this.$props.node ? this.$props.node.server_bundles : [];
            this.inputValue = "";
        }
    },
    mounted() {
        this.fetchServerBundles();
    },
    methods: {
        fetchServerBundles() {
            this.$http.get("/v1/admin/node/server-bundles").then(
                res => {
                    this.serverBundlesOptions = res.data.server_bundles;
                },
                err => {
                    console.error(err);
                },
            );
        },
        addServerBundle(bundleName) {
            this.newServerBundles = [...this.newServerBundles, this.serverBundlesOptions.find(sb => sb.name === bundleName)];
            this.inputValue = "";
        },
        removeServerBundle(id) {
            this.newServerBundles = this.newServerBundles.filter(b => b.id !== id);
        },
        onSubmit() {
            if (this.$props.isShortcutMode) {
                this.saveShortcut();
            } else {
                this.saveNode();
            }
        },
        saveNode() {
            const body = {
                "node_id": this.node.id,
                "server_bundle_ids": this.newServerBundles.map(b => b.id)
            };

            this.$http.post("/v1/admin/node/node/server-bundles/update", body).then(
                () => {
                    this.$notify({
                        group: "foo",
                        title: "Sever bundles updated",
                    });
                    this.$props.onClose(this.node.id, this.newServerBundles);
                },
                err => {
                    this.processing = false;
                    this.errorMsg = err.response.data.message;
                },
            );
        },
        saveShortcut() {
            const body = {
                "shortcut_id": this.node.id,
                "server_bundle_ids": this.newServerBundles.map(b => b.id)
            };

            this.$http.post("/v1/shortcut/server-bundles/update", body).then(
                () => {
                    this.$notify({
                        group: "foo",
                        title: "Sever bundles updated",
                    });
                    this.$props.onClose(this.node.id, this.newServerBundles);
                },
                err => {
                    this.processing = false;
                    this.errorMsg = err.response.data.message;
                },
            );
        }
    }
};
</script>

<style scoped lang="scss">
    .container {
      max-width: 600px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
    }

    .sb-row {
        display: flex;
        max-width: 300px;
        justify-content: space-between;
        align-items: center;

        padding: 4px 8px;
        margin: 0 0 8px;

        &:nth-child(2n) {
          background: #ddd;
          border-radius: 4px;
        }
    }

    .autocomplete-wrapper {
        margin-top: 20px;
        max-width: 300px;
    }

    .cancelButton {
      background-color: #ff5252 !important;
    }
</style>
